import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.css';
import clsx from 'clsx';

interface IAnimatedNudgeProps {
  children: React.ReactNode;
}

const AnimatedNudge: React.FC<IAnimatedNudgeProps> = ({ children }) => {
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [showArrows, setShowArrows] = useState<boolean>(false);
  const animationDuration = 5000;
  const enableAnimationDelay = 500;

  useEffect(() => {
    const startAnimationTimer = setTimeout(() => {
      setIsAnimating(true);

      const stopAnimationTimer = setTimeout(() => {
        setIsAnimating(false);
      }, animationDuration);

      return () => clearTimeout(stopAnimationTimer);
    }, enableAnimationDelay);

    return () => clearTimeout(startAnimationTimer);
  }, []);

  useEffect(() => {
    const startArrowAnimationTimer = setTimeout(() => {
      setShowArrows(true);

      const stopArrowAnimationTimer = setTimeout(() => {
        setShowArrows(false);
      },500);

      return ()=> clearTimeout(stopArrowAnimationTimer);
    }, 1500);
    
    return () => clearTimeout(startArrowAnimationTimer);
  }, [])

  return (
    <div className={styles.animatedContainer}>
      <div className={clsx(styles.contentContainer)}>
        {showArrows &&
          <div className={clsx(styles.arrow, styles.leftArrow)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        }
        {children}
        {showArrows &&
          <div className={clsx(styles.arrow, styles.rightArrow)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        }
      </div>
    </div>
  );
};

export default AnimatedNudge;
